import { CancelTokenSource } from "axios";

export interface ReportState {
	AvailableReports: any[];
	Report: any;
	RelativeHoursToReport: number;
	CurrentReportUrl: string;
	ResultCount: number;
	ReportLoadingStatus: boolean;
	ReportErrorStatus: boolean;
	ReportReferenceIDErrorStatus: boolean;
	ReportApiEndpoint: string;
	ReportTypes: any[];
	isDateRangeRelative: boolean;
    cancelTokenSource: CancelTokenSource | null;
}

export interface ServerTypeFilterOption {
	title: string;
	serverTypeId: number;
}

export interface ServerTypeEventFilterOption {
	title: string;
	// The ReportBuilder expects the filter option to be in this format
	// id = EventNum, id2 = serverTypeId
	id: number;
	id2: number;
}

export interface ReportReferenceIDFilterOption {
	title: string;
	id: string;
}

export const ReportCancelTokenMessage: string = "Insight operation canceled.";
export const ReportCancelTokenNewRequestMessage: string = "Insight operation canceled due to new request.";
